import React, { useEffect, useState } from "react";
import { ICON } from "../../assets";
import { useAuth } from "../Auth/useAuth";
import { useCart } from "../Carts/useCart";
import useConfiguration from "../Configuration/useConfiguration";
import useTranslations from "../Translations/useTranslations";
import UiDateInput from "../ui/UiDateInput";
import UiDropdown from "../ui/UiDropdown";
import UiIcon from "../ui/UiIcon";
import UiInput from "../ui/UiInput";
import UiTooltip from "../ui/UiTooltip";
import "./ClientRecap.css";

function ClientRecap({
  current_cart,
  remise,
  createHeader,
  removeOrderHeader,
  frais_port,
  fildValid,
}) {
  const [{ user }, { isRoleOperator }] = useAuth();
  const [carts, cartSDK] = useCart(user.client_profile?.id);
  const { client, header } = current_cart;

  const trl = useTranslations();
  const config = useConfiguration();

  const [formValid, setFormValid] = useState(fildValid);
  const [refcliextension, setRefCliExtension] = useState("");
  useEffect(() => {
    setFormValid(fildValid);
  }, [fildValid]);
  useEffect(() => {
    const creator = user.client_profile?.id;
    removeOrderHeader({ creator });
    createHeader({ client, remise, frais_port, creator });
    cartSDK.changeHeader("CODVRP", isRoleOperator() ? user.id : null);
    setRefCli("");
  }, []);

  const [formData, setFormData] = useState({
    CODADR_LIV: header?.CODADR_LIV || "",
    CODADR_FAC: header?.CODADR_FAC || "",
    DATE_LIV: header?.DATE_LIV || "",
    refcliextension: refcliextension,
    COMMENTAIRE_LIBRE: header?.COMMENTAIRE_LIBRE || "",
  });

  const [dateError, setDateError] = useState(null);

  const setRefCli = (refcliextension) => {
    cartSDK.changeHeader(
      "REF_CLI",
      `Web ${refcliextension} ${new Date().getDate()}/${new Date().getMonth()}`,
    );
  };

  useEffect(() => {
    Object.keys(formData).forEach((key) => {
      if (key === "refcliextension") {
        setRefCliExtension(formData.refcliextension);
        setRefCli(formData.refcliextension);
      } else if (
        key === "DATE_LIV" ||
        (formData[key] && formData[key] !== "")
      ) {
        cartSDK.changeHeader(key, formData[key]);
      }
    });
  }, [formData]);

  const [paymentMethodShow, setPaymentMethodShow] = useState(false);

  const onPaymentMethodClick = () => {
    setPaymentMethodShow(!paymentMethodShow);
  };

  const deliveryAddressList = header?.addressesLivraison
    ?.sort((a, b) => (a.value < b.value ? -1 : 1))
    .map((address) => ({
      key: address.key,
      label: address.value,
      value: address.value,
    }));

  const billingAddressList = header?.addressFacturation
    ?.sort((a, b) => (a.value < b.value ? -1 : 1))
    .map((address) => ({
      key: address.key,
      label: address.value,
      value: address.value,
    }));

  const handleChange = (event) => {
    const { name, value } = event;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleDropdownSelect = (name, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function deliveryDateChange(e) {
    const targetedDate = e.value;
    const timestr = "" + config.get("dailyOrderLimitTime");
    const todayAtLimit = new Date();

    const hours = parseInt(timestr.substring(0, 2), 10);
    const min = parseInt(timestr.substring(2, 4), 10);
    const sec = parseInt(timestr.substring(4), 10);

    if (timestr) {
      todayAtLimit.setHours(hours, min, sec);
    } else {
      todayAtLimit.setHours(23, 59, 59);
    }
    if (!header?.CODVRP && new Date(targetedDate) < todayAtLimit) {
      let message =
        "Vous ne pouvez pas choisir une date de départ aujourd'hui.";
      if (timestr) {
        message +=
          " L'heure limite pour un départ dans la journée est fixée à " +
          ("" + hours).padStart(2, "0") +
          "h" +
          ("" + min).padStart(2, "0");
      }
      setDateError(message);
      setFormValid((prev) => ({ ...prev, DATE_LIV: true }));
      handleChange({ name: "DATE_LIV", value: null });
    } else {
      setDateError(null);
      setFormValid((prev) => ({ ...prev, DATE_LIV: false }));
      handleChange({ name: "DATE_LIV", value: e.value });
    }
  }

  if (!header) return null;
  return (
    <React.Fragment>
      <div className="client-recap-container">
        <div className="client-recap-title">
          Tous les champs sont obligatoires, sauf ceux indiqués comme étant
          facultatifs
        </div>
        <form className="client-recap-form">
          <div className="client-recap-form-group">
            <label htmlFor="CODADR_LIV">
              {" "}
              {trl.message("FinishOrderPage.Customer.deliveryAddressLabel")} :
            </label>
            <UiDropdown
              options={deliveryAddressList}
              onSelect={(option) => {
                handleDropdownSelect("CODADR_LIV", option ? option.key : "");
              }}
              name="CODADR_LIV"
              placeholder="sélectionnez une adresse"
              value={formData.CODADR_LIV || ""}
              errorMessage="Ce champs est obligatoire"
              throwError={formValid?.CODADR_LIV}
              required={true}
            />
          </div>
          <div className="client-recap-form-group">
            <label htmlFor="CODADR_FAC">
              {" "}
              {trl.message("FinishOrderPage.Customer.billingAddressLabel")} :
            </label>
            <UiDropdown
              options={billingAddressList}
              onSelect={(option) => {
                handleDropdownSelect("CODADR_FAC", option ? option.key : "");
              }}
              name="CODADR_FAC"
              placeholder="sélectionnez une adresse"
              value={formData.CODADR_FAC || ""}
              errorMessage="Ce champs est obligatoire"
              throwError={formValid?.CODADR_FAC}
              required={true}
            />
          </div>
          <div className="client-recap-form-small-group">
            <div className="client-recap-form-group-two">
              <label htmlFor="DATE_LIV">
                {" "}
                {trl.message("FinishOrderPage.Customer.deliveryDateLabel")} :
              </label>
              <UiDateInput
                value={formData.DATE_LIV}
                onChange={deliveryDateChange}
                name="DATE_LIV"
                errorMessage={dateError}
                throwError={formValid?.DATE_LIV}
                required={true}
              />
            </div>
            <div className="client-recap-form-group-two">
              <label htmlFor="paymentMethod">
                {" "}
                {trl.message("FinishOrderPage.Customer.paymentMethod")} :
              </label>
              <div className="payment-method">
                <UiInput
                  className="payment-method-input"
                  value={
                    client.mode_paiement.LIBELLE +
                    " , " +
                    client.paiement_nombre_jours.LIBELLE
                  }
                  name="paymentMethod"
                  style={{ cursor: "pointer" }}
                  readOnly={true}
                  disabled={true}
                />
                <UiTooltip
                  content={
                    <div className="payment-method-tooltip">
                      Contactez
                      <a href="mailto:advfrance@blancreme.com">
                        advfrance@blancreme.com
                      </a>{" "}
                      pour modifier le mode de paiement.
                    </div>
                  }
                  children={<UiIcon icon={ICON.infoIcon} size="md" />}
                />
              </div>
            </div>
          </div>
          {user.data.cmd_facultative !== "O" && (
            <div className="client-recap-form-group">
              <label htmlFor="refcliextension">
                {" "}
                Référence commande :
                <br />
                <small>{`Web ${refcliextension} ${new Date().getDate()}/${new Date().getMonth()}`}</small>
              </label>
              <UiInput
                name="refcliextension"
                value={refcliextension}
                onChange={handleChange}
                errorMessage={"Ce champs est obligatoire"}
              />
            </div>
          )}
          <div className="client-recap-form-group">
            <label htmlFor="extraInformation">
              {" "}
              {trl.message("FinishOrderPage.Customer.extraInformation")}{" "}
              (optionnel) :
              <br />
              <small>
                {trl.message(
                  "FinishOrderPage.Customer.extraInformationDetails",
                )}
              </small>
            </label>
            <textarea
              onChange={(e) =>
                handleChange({
                  name: "COMMENTAIRE_LIBRE",
                  value: e.target.value,
                })
              }
              style={{
                width: "100%",
                border: "none",
                border: "1px solid rgba(0, 0, 0, .1)",
                borderRadius: 5,
              }}
              rows={5}
            ></textarea>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}

export default ClientRecap;
